<template>
  <span v-if="!label && !name && !note">—</span>
  <div v-else class="class-note-cell">
    <span
      v-if="label"
      class="cs-badge"
      :style="badgeStyle"
    >{{ label }}</span>
    <div v-if="name" class="class-note-cell__name class-note-cell__name-row">
      <span>• {{ name }}</span>
      <v-btn
        v-if="showCsCallButton"
        icon
        x-small
        title="عرض المكالمات"
        @click.stop="onShowCsCalls"
      >
        <v-icon color="#3f0e40" small>mdi-phone</v-icon>
      </v-btn>
      <v-btn
        v-if="showAgentCallButton"
        icon
        x-small
        title="عرض المكالمات"
        @click.stop="onShowAgentCalls"
      >
        <v-icon color="#3f0e40" small>mdi-phone</v-icon>
      </v-btn>
    </div>

    <v-tooltip bottom v-if="note">
      <template v-slot:activator="{ on }">
        <div class="class-note-cell__note" v-on="on">
          {{ note.length > noteMax ? note.substring(0, noteMax) + "…" : note }}
        </div>
      </template>
      <div class="font-weight-bold">{{ note }}</div>
    </v-tooltip>
    <div v-if="date" class="class-note-cell__date">{{ date }}</div>
  </div>
</template>

<script>
/**
 * Compact "person + colored classification badge + note" cell.
 *
 * The badge background is ALWAYS the classification's color, falling back to
 * gray (#757575) when none is set. Mirrors the customer-service design but is
 * driven by an explicit `color` prop instead of keyword matching.
 */
export default {
  name: "ClassificationCell",
  props: {
    label: { type: String, default: null },
    color: { type: String, default: null },
    name: { type: String, default: null },
    note: { type: String, default: null },
    date: { type: String, default: null },
    noteMax: { type: Number, default: 30 },
    // Avoid Vue 2 `type: Boolean` — absent/false/null skip binding and coerce oddly.
    hasCsCalls: { default: false },
    hasAgentCalls: { default: false },
    requestId: { type: [Number, String], default: null },
    userNameInCallCenter: { type: String, default: null },
  },
  computed: {
    badgeStyle() {
      const bg = this.color || "#757575";
      return `background-color:${bg} !important;color:#fff !important;`;
    },
    showCsCallButton() {
      return this.isTruthyFlag(this.hasCsCalls);
    },
    showAgentCallButton() {
      return this.isTruthyFlag(this.hasAgentCalls);
    },
  },
  methods: {
    isTruthyFlag(value) {
      return value === true || value === 1 || value === "1" || value === "true";
    },
    onShowCsCalls() {
      this.$emit("show-cs-calls", {
        id: this.requestId,
        customer_service_name: this.name,
      });
    },
    onShowAgentCalls() {
      this.$emit("show-agent-calls", {
        id: this.requestId,
        agent_name: this.userNameInCallCenter,
      });
    },
  },
};
</script>

<style scoped>
.class-note-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  line-height: 1.3;
  padding-top: 10px;
  padding-bottom: 10px;
}

.class-note-cell__name {
  font-weight: 600;
  font-size: 13px;
}

.class-note-cell__name-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cs-badge {
  display: inline-block;
  padding: 1px 7px 3px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 2px;
  color: #fff;
}

.class-note-cell__note {
  font-size: 12px;
  color: #555;
  max-width: 170px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: help;
}

.class-note-cell__date {
  font-size: 10px;
  color: #999;
}

.dark .class-note-cell__note {
  color: #aaa;
}
</style>
